export default __webpack_public_path__ + "static/media/previous-collection--collection-1.09967e86.png";